import { Dialog, DialogProps } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { FC } from 'react';

export const PrescriptionDialogStyle: FC<
  DialogProps & {
    labelledby?: string;
    describedby?: string;
  }
> = (props) => {
  const { onClose, open, labelledby = '', describedby = '' } = props;

  const isDesktop = useIsDesktop();

  const dialogStyle = {
    margin: 'auto',
    maxWidth: '1200px',
    height: isDesktop ? '90vh' : '100vh',
    zIndex: 9999,
  };
  const dialogPaperProps = {
    sx: isDesktop
      ? {
          borderRadius: '24px',
          backgroundColor: 'transparent',
        }
      : {
          borderRadius: 0,
          backgroundColor: '#FFF',
        },
  };
  return (
    <Dialog
      scroll={isDesktop ? 'paper' : 'body'}
      onClose={onClose}
      open={open}
      fullScreen={true}
      fullWidth={true}
      sx={dialogStyle}
      PaperProps={dialogPaperProps}
      aria-labelledby={labelledby}
      aria-describedby={describedby}
    >
      {props.children}
    </Dialog>
  );
};
